import React from 'react'

function Loader({ type = 'fullPage', position = 'fixed', showProcessedRecords = false, processedRecords = 0, width = 40, className, showInprogressOnly = false }) {
  const style = {
    fullPage: `z-[2000] ${position} w-full h-screen top-0 left-0 gap-4 flex flex-col items-center justify-center transparent z-50`,
    fullPageOpaque: `z-[2000] ${position} w-full h-screen top-0 left-0 gap-4 flex flex-col items-center justify-center bg-white z-50`
  }
  return (
    <div className={`${style[type]} ${className}`}>
      {
        showProcessedRecords && (
          <div className='flex flex-col gap-2 items-center justify-center'>
            <div>Processing...</div>
            <div class="flex flex-col items-center space-x-2">
              <div class="text-lg">Processed Records</div>
              <div class="flex items-center justify-center w-auto h-auto text-lg font-bold">
                {processedRecords}
              </div>
            </div>

          </div>
        )
      }
      {
        showInprogressOnly && (
          <div className='flex flex-col gap-2 items-center justify-center'>
            <div class="flex flex-col items-center space-x-2">
              <div class="text-lg">Processing Records</div>
            </div>

          </div>
        )
      }
      <div class="loader">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
  )
}

export default Loader